import { render, staticRenderFns } from "./MyList.vue?vue&type=template&id=00178153&scoped=true&"
import script from "./MyList.vue?vue&type=script&lang=js&"
export * from "./MyList.vue?vue&type=script&lang=js&"
import style0 from "./MyList.vue?vue&type=style&index=0&id=00178153&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00178153",
  null
  
)

export default component.exports